import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { inject, observer } from 'mobx-react'
import './InvitationCard.css'

const InvitationCard = ({ invitation, CommonStore }) => {

    function handleApprove() {
        CommonStore.approveInvitation(invitation.TokenRegister, invitation.KeyCompany)
    }

    function handleReject() {
        CommonStore.rejectInvitation(invitation.TokenRegister, invitation.KeyCompany)
    }

    return (
        <div className="w-100 bg-light border p-3 s-invitation-card-container">
            <h4>{invitation.company}</h4>
            <p className="text-muted small">{invitation.KeyCompany}</p>
            <Row>
                <Col xs={0} sm={7} md={7}></Col>
                <Col xs={12} sm={5} md={5} className="d-flex justify-content-center">
                    <Button variant="danger" className="mr-2" onClick={handleReject}>Rechazar</Button>
                    <Button variant="primary" className="ml-2" onClick={handleApprove}>Aceptar</Button>
                </Col>
            </Row>
        </div>
    )
}

export default inject('CommonStore')(observer(InvitationCard))
